import { Outlet } from "react-router-dom";
import adminRouteMap from "routeControl/adminRouteMap";
import { CmsPages, FAQS } from "pages";

export default function route() {
  return [
    {
      path: adminRouteMap.MANAGE_CMS.path,
      private: true,
      name: "Manage CMS",
      key: adminRouteMap.MANAGE_CMS.path,
      belongsToSidebar: true,
      icon: adminRouteMap.MANAGE_CMS.icon,
      element: <Outlet />,
      children: [
        {
          path: adminRouteMap.ABOUT_US.path,
          private: true,
          name: "About Us",
          key: adminRouteMap.ABOUT_US.path,
          belongsToSidebar: true,
          element: <CmsPages />,
        },
        {
          path: adminRouteMap.PRIVACY_POLICY.path,
          private: true,
          name: "Privacy Policy",
          key: adminRouteMap.PRIVACY_POLICY.path,
          belongsToSidebar: true,
          element: <CmsPages />,
        },
        {
          path: adminRouteMap.FAQS.path,
          private: true,
          name: "FAQ",
          key: adminRouteMap.FAQS.path,
          belongsToSidebar: true,
          element: <FAQS />,
        },
        {
          path: adminRouteMap.TERMS_AND_CONDITION.path,
          private: true,
          name: "Terms and Conditions",
          key: adminRouteMap.TERMS_AND_CONDITION.path,
          belongsToSidebar: true,
          element: <CmsPages />,
        },
      ],
    },
  ];
}
